<template>
<m-pageframe
    title="RedChirp MRR"
>
<v-container
    fluid
    style="padding-right: 15px; padding-left: 15px;"
>
    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        <v-menu 
            bottom 
            offset-y
            slot="append-outer"  
        >
        
        <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-dots-vertical
            </v-icon>
                
        </template>
        
        <v-list>
            <v-list-item
                v-on:click="onClickExport()"
            >
                <v-list-item-title>Export to Excel...</v-list-item-title>
            </v-list-item>
        
        </v-list>
        
        </v-menu> 
    </v-text-field>

    <v-select
        label="States"
        :items="$rc.enumValues('mrr_state')"
        multiple
        chips
        v-model="selected_states"
        v-on:change="doUpdate"
    />
    

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.effective_rate_subscription_milli_cents="{ item }">
            {{$rc.pretty(item.effective_rate_subscription_milli_cents, 'usd')}}
        </template>

         <template v-slot:item.effective_rate_additional_user_milli_cents="{ item }">
            {{$rc.pretty(item.effective_rate_additional_user_milli_cents, 'usd')}}
        </template>

        <template v-slot:item.mav="{ item }">
            {{$rc.pretty(item.mav, 'usd')}}
        </template>

        <template v-slot:item.anticipated_mrr="{ item }">
            {{$rc.pretty(item.anticipated_mrr, 'usd')}}
        </template>

         <template v-slot:item.mrr="{ item }">
            {{$rc.pretty(item.mrr, 'usd')}}
        </template>

       

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickSetState(item)"
                >
                    <v-list-item-title>Set State...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSetMinUsers(item)"
                >
                    <v-list-item-title>Minimum Users...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <div>
        <div
            style="float: left; width: 60%; margin-top: 15px;"
        >

        <p><b>MAV</b> - Monthly Account Value - Monthly Subscription Revenue + Monthly Revenue from Additional Employees</p>

        <p><b>States</b></p>

        <p><b>non-revenue</b> - The organization is not anticipated to contribute to MRR</p>

        <p><b>enrolling</b> - The account has given at least verbal yes and is in the process of getting ready to start a trail or go active</p>

        <p><b>trial</b> - The account has:
            <ul>
                <li>Selected their plan</li>
                <li>Selected a start date for a free trail period</li>
                <li>Submitted signed paperwork</li>
            </ul>
        </p>

        <p><b>ready</b> - The account has:
            <ul>
                <li>Selected their plan</li>
                <li>Selected a date where they will go active</li>
                <li>Submitted signed paperwork</li>
                <li>Decided no free trial is required or has completed their free trial period</li>
            </ul>
        </p>

        <p><b>active</b> - The organization is being billed</p>

        <p><b>cancelled</b> - The organization has cancelled RedChirp</p>

        <p><b>MRR</b> - The MAV of all active accounts</p>

        <p><b>Anticipated Monthly Recurring Revenue (AMRR) </b> = MAV[active] + MAV[ready] x 80% + MAV[trial] x 80%</p>
    </div>
    <div
        v-if="cur_totals != null"
        style="float: right; margin-top: 15px; font-family: monospace"
    >
        MAV[enrolling] = {{$rc.pretty(cur_totals.mav_enrolling_milli_cents,'usd')}}<br/>
        MAV[trial] = {{$rc.pretty(cur_totals.mav_trial_milli_cents,'usd')}}<br/>
        MAV[ready] = {{$rc.pretty(cur_totals.mav_ready_milli_cents,'usd')}}<br/>
        MAV[active] = {{$rc.pretty(cur_totals.mav_active_milli_cents,'usd')}}<br/>
        MAV[total] = {{$rc.pretty(cur_totals.mav_enrolling_milli_cents + cur_totals.mav_active_milli_cents + cur_totals.mav_trial_milli_cents + cur_totals.mav_ready_milli_cents,'usd')}}<br/><br/>

        MRR = {{$rc.pretty(cur_totals.mav_active_milli_cents,'usd')}}<br/>
        AMRR = {{$rc.pretty(cur_totals.mav_active_milli_cents + cur_totals.mav_trial_milli_cents*0.8 + cur_totals.mav_ready_milli_cents*0.8,'usd')}}<br/><br/>
        
    </div>

    

    <div
        style="clear: both;"
    >
    </div>
    </div>

    <m-edit-text-dialog
        ref="edit-min-users"
        v-on:ok="onSetMinUsers($event)"
        :rules="validationRules()"
    />

</v-container>
</m-pageframe>
</template>

<script>
import adminProcessorsVue from '../admin/admin-processors.vue';
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            results: [],
            selected_states: ['non-revenue', 'enrolling','trial','ready','active'],
            action_organization_id: null,
            cur_totals: null,

            headers: [
                { text: 'Organization Name', value: 'organization_label'},
                { text: 'Industry', value: 'organization_industry'},
                { text: 'Rate Card', value: 'rate_card_label'},
                { text: 'Subscription Rate', value: 'effective_rate_subscription_milli_cents'},
                { text: 'Additional User Rate', value: 'effective_rate_additional_user_milli_cents'},
                { text: 'Included Users', value: 'effective_included_users'},
                { text: 'Min User Count', value: 'mrr_minimum_user_count'},
                { text: 'Active User Count', value: 'mrr_current_user_count'},
                { text: 'Billing Additional Users', value: 'mrr_additional_user_count'},
                { text: 'MAV', value: 'mav'},
                { text: 'State', value: 'mrr_state'},
                { text: 'AMRR', value: 'anticipated_mrr'},
                { text: 'MRR', value: 'mrr'},
                { text: 'Action', value: 'action'}
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: 
    {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest(
                'LIST: /organizations/mrr',
            
                {
                    'full_text' : this.full_text,
                    'mrr_state' : this.selected_states,
                },
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to update MRR table');
                },
            );

            this.$rc.rest(
                'GET-PROFILE: /api/v1/organizations/mrr',
            
                {
                },
            
                (data) => {
                    this.cur_totals = data.cur_totals;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to get MRR profile');
                },
            );
        },

        onClickSetState(item)
        {
            this.$rc.pick({
                'title': 'Select MRR State: '+item.organization_label,
                'content_before': 'Choose the MRR state of the organization '+item.organization_label,
                'content_after': null,
            
                'choices': this.$rc.enumValues('mrr_state'),
            
                'multiple': false,
                'type': 'select',
                'select_label': 'New MRR State',
                'initial_value': item.mrr_state,
            
                'on_ok': (value) => {

                    this.patch({
                        'organization_id' : item.organization_id,
                        'mrr_state': value
                    });
                },
            
                'on_cancel': () => {}
            
            });
        },

       
      
        onClickSetMinUsers(item)
        {
            this.action_organization_id = item.organization_id;
            this.$refs['edit-min-users'].showDialog('Minimum Users', item.mrr_minimum_user_count);   
        },

        onSetMinUsers(value)
        {
            this.patch({
                'organization_id' : this.action_organization_id,
                'mrr_minimum_user_count': value
            });
        },

        patch(params)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PATCH: /api/v1/organizations/mrr',
            
                'params' : params,
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to update organization MRR state',
            });
        },

        validationRules()
        {
            let integer = value => {
                if ( value == null ) return 'Must be an integer';
                if ( isNaN(Number(value)) || Number(value) != parseInt(value) ) return 'Must be an integer';
                return true;
            };

            return [integer];
        },

        onClickExport() {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/organizations/mrr',
                    {
                    }
                );
        },
    },
}
</script>

<style lang="scss" scoped>
</style>